import { SETTING_API } from "@/configs/api";
export default ($axios) => ({
	/**
	 * Get tracking setting
	 * @returns
	 */
	async getTrackingSetting() {
		const {
			data: { code, data },
		} = await $axios.get(SETTING_API.TRACKING);
		return { code, data };
	},
});
